import VueRouter from 'vue-router'
import Vue from 'vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'chat',
    component: () => import('@/views/EmbedChat/EmbedChatView.vue')
  }
];

const router = new VueRouter({
  routes
})

export default router;
